import type React from 'react';
import Fields from './Fields';
import { type DrawerProps, renderPath } from '../Drawer';

const SettingsComponents: Record<string, React.FC<DrawerProps>> = {
  fields: Fields,
};

const Settings: React.FC<DrawerProps> = ({ paths, fullPath }) => {
  return renderPath(paths, fullPath, SettingsComponents);
};

export default Settings;
